<template>
  <v-card class="bg-background pa-10 ma-10">
    <v-card-title>{{ personName }}</v-card-title>
    <v-card-text>{{ cardNum }}</v-card-text>
    <v-progress-linear
      indeterminate
      color="primary"
      height="10"
    ></v-progress-linear>
    <v-img
      :width="300"
      aspect-ratio="16/9"
      cover
      :src="'/api/generateBarcodeImage?number=' + cardNum"
    ></v-img>
    <v-progress-linear
      indeterminate
      reverse
      color="primary"
      height="10"
    ></v-progress-linear>
    <v-card-actions> </v-card-actions>
  </v-card>
</template>
<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useUser } from "@/composables/useUser";
import { PersonNameInfoClass } from "@/api/dto/PersonNameInfo";

const router = useRouter();

const authStore = useAuthStore();

const route = useRoute();

const person = useUser();

const personName = computed(() =>
  new PersonNameInfoClass(person.currentPersonRef.value).getFullName(),
);

const cardNum = computed(() => route.params.number);

async function toLogin() {
  await authStore.logout();
  router.push({ name: "registration" });
}
</script>
